import React from 'react';
import classnames from 'classnames';
import { SvgIcon } from '@material-ui/core';
import { makeStyles } from '@knockrentals/knock-shared-web';

const useStyles = makeStyles({
  renterAINavbarIcon: {
    marginRight: '6.5px',
  },
});

export const RenterAINavbarIcon = ({ className, ...props }) => {
  const classes = useStyles();

  return (
    <SvgIcon className={classnames(classes.renterAINavbarIcon, className)} {...props}>
      <svg
        width="22"
        height="22"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_3709_6690)">
          <path
            d="M15.7056 11.9458C12.8522 11.9458 10.5311 9.61165 10.5311 6.74223C10.5311 6.63163 10.442 6.54205 10.332 6.54205C10.2221 6.54205 10.133 6.63163 10.133 6.74223C10.133 9.61165 7.81187 11.9458 4.9585 11.9458C4.84855 11.9458 4.75946 12.0354 4.75946 12.146C4.75946 12.2566 4.84855 12.3462 4.9585 12.3462C7.81187 12.3462 10.133 14.6804 10.133 17.5498C10.133 17.6604 10.2221 17.75 10.332 17.75C10.442 17.75 10.5311 17.6604 10.5311 17.5498C10.5311 14.6804 12.8522 12.3462 15.7056 12.3462C15.8155 12.3462 15.9046 12.2566 15.9046 12.146C15.9046 12.0354 15.8155 11.9458 15.7056 11.9458Z"
            fill="white"
          />
          <path
            d="M10.67 2.00921C9.74114 2.00921 8.98553 1.24939 8.98553 0.315211C8.98553 0.279202 8.9565 0.25 8.92071 0.25C8.88492 0.25 8.85583 0.279202 8.85583 0.315211C8.85583 1.24939 8.10029 2.00921 7.17132 2.00921C7.13554 2.00921 7.10651 2.03842 7.10651 2.07443C7.10651 2.11043 7.13554 2.13963 7.17132 2.13963C8.10029 2.13963 8.85583 2.89945 8.85583 3.83363C8.85583 3.86964 8.88492 3.89884 8.92071 3.89884C8.9565 3.89884 8.98553 3.86964 8.98553 3.83363C8.98553 2.89945 9.74114 2.13963 10.67 2.13963C10.7059 2.13963 10.7349 2.11043 10.7349 2.07443C10.7349 2.03842 10.7059 2.00921 10.67 2.00921Z"
            fill="white"
          />
          <path
            d="M7.96803 6.41333C6.27112 6.41333 4.8908 5.02526 4.8908 3.31879C4.8908 3.25301 4.83779 3.19971 4.77239 3.19971C4.70698 3.19971 4.65398 3.25301 4.65398 3.31879C4.65398 5.02526 3.27365 6.41333 1.57672 6.41333C1.51132 6.41333 1.45831 6.46663 1.45831 6.53241C1.45831 6.5982 1.51132 6.6515 1.57672 6.6515C3.27365 6.6515 4.65398 8.03963 4.65398 9.74606C4.65398 9.81184 4.70698 9.86515 4.77239 9.86515C4.83779 9.86515 4.8908 9.81184 4.8908 9.74606C4.8908 8.03963 6.27112 6.6515 7.96803 6.6515C8.03347 6.6515 8.08643 6.5982 8.08643 6.53241C8.08643 6.46663 8.03347 6.41333 7.96803 6.41333Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_3709_6690">
            <rect width="17.5" height="17.5" fill="white" transform="translate(0 0.25)" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};
